import React from "react"
import { FaRegQuestionCircle } from "react-icons/fa"
import { type Props } from "./_types"
const IconQuestion: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <FaRegQuestionCircle size={size} color={color} />
}

export default IconQuestion
